import { FormProvider, useForm } from 'react-hook-form';
import { IJobDescription } from '@/states/job.state';
import JobDescriptionContent from '@/components/company/job/JobDescriptionContent';

export default function DownloadDocument() {
  const formControl = useForm<IJobDescription>({
    defaultValues: { name: '' },
  });

  return (
    <FormProvider {...formControl}>
      <JobDescriptionContent mode="download" />
    </FormProvider>
  );
}
